import { prospectDetailsStore, setProspectDetailsStore } from '@store/prospect';
import { unwrap } from 'solid-js/store';
import { ValidationError } from 'yup';

import { prospectDetailsSchema } from '../validations';

export const validateFieldForProspect = async (
  validatePath: string,
  errorPath: string,
) => {
  const updateErrors = (error: unknown) => {
    const updatedErrors = {
      ...(unwrap(prospectDetailsStore.prospectDetailsErrors) || {}),
      [errorPath]: error,
    };
    if (error === undefined || error === null) delete updatedErrors[errorPath];
    setProspectDetailsStore(() => ({
      prospectDetailsErrors: updatedErrors as Record<string, string[]>,
    }));
  };
  try {
    await prospectDetailsSchema.validateAt(
      validatePath,
      prospectDetailsStore.prospectDetails,
    );
    updateErrors(undefined);
  } catch (validationError: unknown) {
    if (validationError instanceof ValidationError) {
      updateErrors(validationError.errors);
    }
  }
};
